<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-22 16:45:00
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refunddetail/components/TopStep/index.vue
-->
<template>
  <div class="con">
    <div
      v-for="(item, index) in stepList"
      :key="index"
      class="font12 font_weight500 colof step step1 line_height_17"
    >
      <div class="step_top">
        <div
          :class="{
            line_color: index > activeStepIndex,
            none_line: index === 0
          }"
          class="line"
        ></div>
        <img
          :src="index <= activeStepIndex ? item.iconUrl : item.iconUrl2"
          alt=""
          class="step_img"
        />
        <div
          :class="{
            line_color: index > activeStepIndex,
            none_line: index === stepList.length - 1
          }"
          class="line"
        ></div>
      </div>
      <div class="step_det">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    getAfterSaleInfo() {
      return this.$store.getters.getAfterSaleInfo || {};
    },
    isRefund() {
      // afterSaleType: 0仅退款，1退款退货
      return this.getAfterSaleInfo.afterSaleType === 0;
    },
    stepList() {
      const refundTitleList = [
        "申请售后",
        "店主审核中",
        "客服审核中",
        "售后完成"
      ];
      const returnRefundTitleList = [
        "申请售后",
        "店主审核中",
        "客服审核中",
        "待商品寄回",
        "商家待收货",
        "售后完成"
      ];
      const titles = this.isRefund ? refundTitleList : returnRefundTitleList;
      return titles.map(name => ({
        iconUrl: require("@/assets/order/step_icon1@2x.png"),
        iconUrl2: require("@/assets/order/step_icon2@2x.png"),
        name
      }));
    },
    activeStepIndex() {
      const maxIndex = this.stepList.length - 1;
      return this.stepIndex >= maxIndex ? maxIndex : this.stepIndex;
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: linear-gradient(90deg, #bf9264 0%, #e1c49d 100%);
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 24px 0 37px;
  .step {
    flex: 1;
  }
  .step_top {
    display: flex;
    .step_img {
      width: 18px;
    }
    .line {
      bottom: 50%;
      transform: translateY(-50%);
      border-bottom: 2px solid rgba(255, 255, 255, 1);
      width: 100%;
    }
    .line_color {
      border-bottom: 2px solid rgba(255, 255, 255, 0.4) !important;
    }
    .none_line {
      border-bottom: 1px solid transparent !important;
    }
  }
  .step_det {
    margin-top: 8px;
  }
}
</style>
